(function ($) {
  'use strict';

  /**
   * A11y Dropdown Controls
   * ---
   * - a11y - Adds Aria attrs
   * - a11y - Uses `aria-controls` attr to target dropdown el
   * - a11y - Focus handling & optional `focus_first_input`
   * - Button & Dropdown el must be placed next to eachother
   */

  $.fn.dropdownControls = function (args) {
    args = $.extend({
      focus_first_input: true,
    }, args );
    var $this_button = $(this);
    var $this_dropdown = $this_button
      .next( '#' + $this_button.attr('aria-controls') );
    var focus_first_input = args.focus_first_input;
    var $this_close_button = $this_dropdown.find('.js-dropdown-close');

    // Wrap button and dropdown container
    // - Helps control positioning via authored CSS
    $this_button
      .add( $this_dropdown )
      .wrapAll( '<div class="dropdown-toggle-group" />' );

    // Prep button & dropdown els
    $this_button.attr( 'aria-expanded', 'false' );
    $this_dropdown.css( 'display', 'none' );


    /**
     * Button Toggle Controls
     */
    $this_button.on('click', function (e) {
      e.preventDefault();
      var is_dropdown_expanded = $this_button.attr('aria-expanded') === 'true';

      // Show Dropdown
      if ( ! is_dropdown_expanded ) {
        show_dropdown( $this_button, $this_dropdown, focus_first_input );

      // Hide Dropdown
      } else {
        hide_dropdown( $this_button, $this_dropdown, false );
      }

      return false;
    });


    /**
     * Close on esc keypress
     */
    $(document).on('keydown', function (e) {
      var is_dropdown_expanded = $this_button.attr('aria-expanded') === 'true';

      if ( e.key === 'Escape'
        && is_dropdown_expanded ) {
        hide_dropdown( $this_button, $this_dropdown, true );
      }
    });


    /**
     * Close on click/tab outside
     */
    $(document).on('click focusin', function (e) {
      if ( $this_dropdown.length
        && $this_dropdown.is(':visible') ) {
        var $dropdown_parent = $this_button.parent();

        // Close when _not_ tabbing to back to dropdown button
        if ( ! $(e.target).closest( $dropdown_parent ).length ) {
          hide_dropdown( $this_button, $this_dropdown, false );
        }
      }
    });


    /**
     * Close on "Close Button" Press
     */
    $this_close_button.on('click', function () {
      var is_dropdown_expanded = $this_button.attr('aria-expanded') === 'true';

      if ( is_dropdown_expanded ) {
        hide_dropdown( $this_button, $this_dropdown, true );
      }
    });

    return this;
  };


  /**
   * Show Dropdown
   */
  function show_dropdown( $button_el, $dropdown_el, is_focus_first_input ) {
    $button_el.attr( 'aria-expanded', 'true' );
    $dropdown_el.css( 'display', 'block' );

    // If enabled, focus first input
    if ( is_focus_first_input ) {

      // Get & check first el
      var $first_el = $dropdown_el
        .find( 'input, button, a[href]' )
        .not( '[disabled]' )
        .filter( ':visible' )
        .first();
      var is_first_input = $first_el.is( 'input' );

      // Focus if first el is an input
      if ( is_first_input ) {
        $first_el.focus();
      }
    }
  }


  /**
   * Hide Dropdown
   */
  function hide_dropdown( $button_el, $dropdown_el, is_retain_focus ) {
    $button_el.attr( 'aria-expanded', 'false' );
    $dropdown_el.css( 'display', 'none' );

    if ( is_retain_focus ) {
      $button_el.focus();
    }
  }

})(jQuery);
